var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"front-page "},[(_vm.$store.state.mediaPhone)?_c('m_header'):_vm._e(),_c('fp_header'),_c('process',{attrs:{"process":_vm.process}}),_c('activity',{attrs:{"activity":_vm.activity}}),_c('info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }